import { o as e, r as t } from "./dist-C5MhUQHh.js";
import * as n from "@apollo/client";
import { gql as r } from "@apollo/client";
//#region ../delivery-common/src/graphql.ts
var i = {}, a = /* @__PURE__ */ function(e) {
	return e.Negative = "NEGATIVE", e.Positive = "POSITIVE", e;
}({}), o = /* @__PURE__ */ function(e) {
	return e.Ar = "ar", e.Bg = "bg", e.Ca = "ca", e.CaValencia = "ca_valencia", e.Cs = "cs", e.Da = "da", e.De = "de", e.DeAt = "de_at", e.DeBe = "de_be", e.DeCh = "de_ch", e.Ee = "ee", e.El = "el", e.En = "en", e.EnAu = "en_au", e.EnCa = "en_ca", e.EnGb = "en_gb", e.EnIe = "en_ie", e.EnNz = "en_nz", e.EnUs = "en_us", e.Es = "es", e.Es_419 = "es_419", e.Et = "et", e.Eu = "eu", e.Fa = "fa", e.Fi = "fi", e.Fr = "fr", e.FrBe = "fr_be", e.FrCa = "fr_ca", e.FrCh = "fr_ch", e.Gl = "gl", e.Hi = "hi", e.Hr = "hr", e.Hu = "hu", e.Id = "id", e.Is = "is", e.It = "it", e.ItCh = "it_ch", e.Iw = "iw", e.Ja = "ja", e.Ko = "ko", e.Lt = "lt", e.Lv = "lv", e.Nb = "nb", e.Nl = "nl", e.NlBe = "nl_be", e.Nn = "nn", e.No = "no", e.Pl = "pl", e.Pt = "pt", e.PtBr = "pt_br", e.Ro = "ro", e.Ru = "ru", e.Sk = "sk", e.Sl = "sl", e.Sq = "sq", e.Sr = "sr", e.Sv = "sv", e.Th = "th", e.Tr = "tr", e.Uk = "uk", e.Vi = "vi", e.Zh = "zh", e.ZhHant = "zh_hant", e;
}({}), s = r`
  fragment ArticleAvailability on AvailableAtPayload {
    helpCenters {
      name
      url
    }
    internalKbs {
      name
      collectionId
      iconColor
    }
  }
`, c = r`
  fragment ArticleSearchResult on PublishedArticle {
    id
    title
    parentCategory {
      id
      title
    }
    tags {
      id
      name
    }
    collectionId
    availableAt {
      ...ArticleAvailability
    }
  }
  ${s}
`, l = r`
  fragment InternalKbFields on Collection {
    id
    title
    internalKbEnabled
    linkedResources {
      id
      type
      name
    }
  }
`, u = r`
  fragment InternalKbCategoryFields on KbCategory {
    id
    title
    parentCategory {
      id
    }
  }
`, d = r`
  fragment InternalKbArticleAvailability on KbArticle {
    availableAt {
      ...ArticleAvailability
    }
  }
  ${s}
`, f = r`
  fragment InternalKbArticleFields on KbArticle {
    id
    title
    publishedAt
    parentCategory {
      id
    }
  }
`, p = r`
  fragment InternalKbArticleContent on KbArticle {
    parentCategory {
      id
      title
    }
    content {
      html
      cssVersion
    }
    publishedBy {
      name
    }
    tags {
      id
      name
      color
      type
      isDeactivated
    }
  }
`, m = r`
  fragment DeliveryOrganizationSettings on OrganisationSettingsPayload {
    defaultLanguage {
      ...LanguageFields
    }
    enabledLanguages {
      ...LanguageFields
    }
  }
  ${r`
  fragment LanguageFields on Language {
    languageId
    description
    nativeDescription
  }
`}
`;
r`
  query Article($id: ID!, $languageId: LanguageId!, $collectionId: ID!) {
    suggestions {
      article(id: $id, languageId: $languageId, collectionId: $collectionId) {
        id
        tags {
          id
          name
          type
          isDeactivated
        }
        title
        content {
          html
          cssVersion
        }
        updatedAt
        languageId
        parentCategory {
          title
          id
        }
        collectionId
        availableAt {
          ...ArticleAvailability
        }
      }
    }
  }
  ${s}
`, r`
  query ArticleSearchTerms(
    $languageId: LanguageId!
    $limit: Limit!
    $searchTerms: NonEmptyString!
    $collectionIds: [ID!]!
    $tagIds: [ID!]
  ) {
    suggestions {
      articleSearch(
        languageId: $languageId
        limit: $limit
        collectionIds: $collectionIds
      ) {
        byTerms(searchTerms: $searchTerms, tagIds: $tagIds) {
          results {
            ...ArticleSearchResult
          }
        }
      }
    }
  }
  ${c}
`, r`
  query Collections {
    collections {
      results {
        id
        title
        linkedResources {
          id
        }
      }
    }
  }
`, r`
  query ConversationSuggestions(
    $languageId: LanguageId!
    $csid: Long!
    $limit: Limit!
  ) {
    suggestions {
      conversation(csid: $csid, languageId: $languageId) {
        articles(limit: $limit) {
          results {
            ...ArticleSearchResult
          }
          searchMethodsUsed
        }
      }
    }
  }
  ${c}
`, r`
  query ExternalResource($id: ID!, $type: ExternalResourceType!) {
    externalResource(id: $id, type: $type) {
      linkedCollections {
        id
        title
      }
    }
  }
`;
var h = r`
  query InternalKbArticle(
    $collectionId: ID!
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    knowledgeBaseArticle: knowledgeBase(
      collectionId: $collectionId
      languageId: $languageId
    ) {
      article(id: $articleId) {
        ...InternalKbArticleFields
        ...InternalKbArticleContent
        ...InternalKbArticleAvailability
      }
    }
  }
  ${f}
  ${p}
  ${d}
`;
function g(e) {
	let t = {
		...i,
		...e
	};
	return n.useQuery(h, t);
}
var _ = r`
  query InternalKbCollection($collectionId: ID!, $languageId: LanguageId!) {
    knowledgeBase(collectionId: $collectionId, languageId: $languageId) {
      collection {
        ...InternalKbFields
      }
      theme {
        colors {
          icon
        }
      }
      description
      categories {
        ...InternalKbCategoryFields
        categories {
          ...InternalKbCategoryFields
          categories {
            ...InternalKbCategoryFields
            categories {
              ...InternalKbCategoryFields
              categories {
                ...InternalKbCategoryFields
                articles {
                  ...InternalKbArticleFields
                }
              }
              articles {
                ...InternalKbArticleFields
              }
            }
            articles {
              ...InternalKbArticleFields
            }
          }
          articles {
            ...InternalKbArticleFields
          }
        }
        articles {
          ...InternalKbArticleFields
        }
      }
    }
  }
  ${l}
  ${u}
  ${f}
`;
function v(e) {
	let t = {
		...i,
		...e
	};
	return n.useQuery(_, t);
}
var y = r`
  query InternalKbs($languageId: LanguageId) {
    knowledgeBases(languageId: $languageId) {
      results {
        collection {
          id
        }
        title
        description
        theme {
          colors {
            icon
          }
        }
      }
    }
  }
`;
function b(e) {
	let t = {
		...i,
		...e
	};
	return n.useQuery(y, t);
}
var x = r`
  query InternalKbSearch(
    $collectionId: ID!
    $languageId: LanguageId!
    $searchTerms: NonEmptyString!
    $limit: Limit
    $offset: Offset
  ) {
    knowledgeBase(collectionId: $collectionId, languageId: $languageId) {
      articleSearch(searchTerms: $searchTerms, limit: $limit, offset: $offset) {
        results {
          ...InternalKbArticleFields
          searchMatchedOn {
            body
          }
          parentCategory {
            id
            title
          }
        }
      }
    }
  }
  ${f}
`;
function S(e) {
	let t = {
		...i,
		...e
	};
	return n.useQuery(x, t);
}
var C = r`
  query OrganizationSettings {
    organisationSettings {
      ...DeliveryOrganizationSettings
    }
  }
  ${m}
`;
function w(e) {
	let t = {
		...i,
		...e
	};
	return n.useQuery(C, t);
}
var ee = r`
  mutation ArticleRatingTrack(
    $articleId: ID!
    $languageId: LanguageId!
    $rating: ArticleRating!
    $ctx: EventCtxInput!
  ) {
    articleRatingSubmit(
      articleId: $articleId
      languageId: $languageId
      rating: $rating
      ctx: $ctx
    ) {
      eventId
    }
  }
`;
function te(e) {
	let t = {
		...i,
		...e
	};
	return n.useMutation(ee, t);
}
var ne = r`
  mutation ArticleViewTrack(
    $articleId: ID!
    $languageId: LanguageId!
    $ctx: EventCtxInput!
  ) {
    articleViewTrack(
      articleId: $articleId
      languageId: $languageId
      ctx: $ctx
    ) {
      eventId
    }
  }
`;
function re(e) {
	let t = {
		...i,
		...e
	};
	return n.useMutation(ne, t);
}
var T = r`
  mutation SearchQueryTrack(
    $searchInput: ArticleSearchInput!
    $searchResults: [ID!]!
    $ctx: EventCtxInput!
  ) {
    searchQueryTrack(
      searchInput: $searchInput
      searchResults: $searchResults
      ctx: $ctx
    ) {
      eventId
    }
  }
`;
function ie(e) {
	let t = {
		...i,
		...e
	};
	return n.useMutation(T, t);
}
//#endregion
//#region ../utils/src/routes.ts
var E = (/* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.path = void 0;
	function t(e) {
		let a = n(e), o = (e) => "/" + a.map((t) => t.kind === "param" ? i(e, t.paramName) : t.value).filter((e) => e !== "").join("/");
		if (o.pattern = r(e), o.parts = a, o.path = (n) => t(`${e}/${n}`), !o.pattern.startsWith("/")) throw Error(`Paths must begin with slashes, but ${JSON.stringify(o.pattern)} doesn't.`);
		return o;
	}
	e.path = t;
	function n(e) {
		return e.split("/").map((e) => e.startsWith(":") ? {
			kind: "param",
			paramName: e.replace(/^:/, "")
		} : {
			kind: "constant",
			value: e
		});
	}
	function r(e) {
		return e === "/" ? e : e.replace(/\/+/g, "/").replace(/^(.+)\/$/, (e, t) => t);
	}
	function i(e, t) {
		let n = e[t];
		if (typeof n != "string") throw Error(`When generating a path, the path param ${JSON.stringify(t)} didn't exist on params object ${JSON.stringify(e)}. The types should have prevented this, so either you defeated them (e.g., with \`as\`) or this is a bug!`);
		return n;
	}
})))(), D = (0, E.path)("/knowledge"), ae = D.path("/collection"), O = D.path("/collection/:collectionId"), k = D.path("/settings"), A = k.path("/ai-suggestions"), j = A.path("/versions"), oe = j.path("/:versionId"), M = D.path("/article-editor/:articleId"), se = M.path("/version-history"), N = D.path("/articles"), ce = D.path("/article-suggestions"), P = (0, E.path)("/internal-kb"), le = P.path("/collection/:collectionId"), ue = P.path("/collection/:collectionId/article/:articleId"), F = (0, E.path)("/settings").path("/help-centers"), de = F.path("/:helpCenterId"), fe = {
	content: () => ae({}),
	articleSuggestions: () => ce({}),
	articles: (e) => e?.length ? `${N({})}?${e}` : N({}),
	collectionEdit: ({ collectionId: e, articlesFiltersStore: n }) => {
		let { collectionId: r, ...i } = n, a = t(i);
		return a.length ? `${O({ collectionId: e })}?${a}` : O({ collectionId: e });
	},
	articleVersionHistory: ({ articleId: e, languageId: t }) => {
		let n = se({ articleId: e });
		return t ? `${n}?langId=${t}` : n;
	},
	articleEdit: ({ articleId: e, collectionId: t, languageId: n }) => {
		let r = {};
		n && (r.langId = n), t && (r.collectionId = t);
		let i = Object.keys(r).length > 0 ? new URLSearchParams(r).toString() : "";
		return `${M({ articleId: e })}${i.length ? `?${i}` : ""}`;
	},
	knowledgeSettingsPath: () => k({}),
	aiSuggestionsSettings: () => A({}),
	aiSuggestionsVersions: () => j({}),
	aiSuggestionsVersion: ({ versionId: e }) => oe({ versionId: e }),
	internalKBDashboard: () => P({}),
	internalKBCollection: ({ collectionId: e }) => le({ collectionId: e }),
	internalKBArticle: ({ collectionId: e, articleId: t, languageId: n }) => ({
		path: ue({
			collectionId: e,
			articleId: t
		}),
		search: `langId=${n}`
	}),
	helpCentersPath: () => F({}),
	helpCenterSettingsPath: ({ helpCenterId: e }) => de({ helpCenterId: e })
}, I = Symbol(), L = Symbol(), R = "a", z = "w", B = (e, t) => new Proxy(e, t), V = Object.getPrototypeOf, H = /* @__PURE__ */ new WeakMap(), U = (e) => e && (H.has(e) ? H.get(e) : V(e) === Object.prototype || V(e) === Array.prototype), W = (e) => typeof e == "object" && !!e, pe = (e) => {
	if (Array.isArray(e)) return Array.from(e);
	let t = Object.getOwnPropertyDescriptors(e);
	return Object.values(t).forEach((e) => {
		e.configurable = !0;
	}), Object.create(V(e), t);
}, G = (e) => e[L] || e, K = (e, t, n, r) => {
	if (!U(e)) return e;
	let i = r && r.get(e);
	if (!i) {
		let t = G(e);
		i = ((e) => Object.values(Object.getOwnPropertyDescriptors(e)).some((e) => !e.configurable && !e.writable))(t) ? [t, pe(t)] : [t], r?.set(e, i);
	}
	let [a, o] = i, s = n && n.get(a);
	return s && s[1].f === !!o || (s = ((e, t) => {
		let n = { f: t }, r = !1, i = (t, i) => {
			if (!r) {
				let r = n[R].get(e);
				if (r || (r = {}, n[R].set(e, r)), t === z) r[z] = !0;
				else {
					let e = r[t];
					e || (e = /* @__PURE__ */ new Set(), r[t] = e), e.add(i);
				}
			}
		}, a = {
			get: (t, r) => r === L ? e : (i("k", r), K(Reflect.get(t, r), n[R], n.c, n.t)),
			has: (t, a) => a === I ? (r = !0, n[R].delete(e), !0) : (i("h", a), Reflect.has(t, a)),
			getOwnPropertyDescriptor: (e, t) => (i("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
			ownKeys: (e) => (i(z), Reflect.ownKeys(e))
		};
		return t && (a.set = a.deleteProperty = () => !1), [a, n];
	})(a, !!o), s[1].p = B(o || a, s[0]), n && n.set(a, s)), s[1][R] = t, s[1].c = n, s[1].t = r, s[1].p;
}, q = (e, t, n, r, i = Object.is) => {
	if (i(e, t)) return !1;
	if (!W(e) || !W(t)) return !0;
	let a = n.get(G(e));
	if (!a) return !0;
	if (r) {
		let n = r.get(e);
		if (n && n.n === t) return n.g;
		r.set(e, {
			n: t,
			g: !1
		});
	}
	let o = null;
	try {
		for (let n of a.h || []) if (o = Reflect.has(e, n) !== Reflect.has(t, n), o) return o;
		if (!0 === a[z]) {
			if (o = ((e, t) => {
				let n = Reflect.ownKeys(e), r = Reflect.ownKeys(t);
				return n.length !== r.length || n.some((e, t) => e !== r[t]);
			})(e, t), o) return o;
		} else for (let n of a.o || []) if (o = !!Reflect.getOwnPropertyDescriptor(e, n) != !!Reflect.getOwnPropertyDescriptor(t, n), o) return o;
		for (let s of a.k || []) if (o = q(e[s], t[s], n, r, i), o) return o;
		return o === null && (o = !0), o;
	} finally {
		r && r.set(e, {
			n: t,
			g: o
		});
	}
}, me = (e) => U(e) && e[L] || null, J = (e, t = !0) => {
	H.set(e, t);
}, Y = (e) => typeof e == "object" && !!e, X = /* @__PURE__ */ new WeakMap(), Z = /* @__PURE__ */ new WeakSet(), [he] = ((e = Object.is, t = (e, t) => new Proxy(e, t), n = (e) => Y(e) && !Z.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer), r = (e) => {
	switch (e.status) {
		case "fulfilled": return e.value;
		case "rejected": throw e.reason;
		default: throw e;
	}
}, i = /* @__PURE__ */ new WeakMap(), a = (e, t, n = r) => {
	let o = i.get(e);
	if (o?.[0] === t) return o[1];
	let s = Array.isArray(e) ? [] : Object.create(Object.getPrototypeOf(e));
	return J(s, !0), i.set(e, [t, s]), Reflect.ownKeys(e).forEach((t) => {
		if (Object.getOwnPropertyDescriptor(s, t)) return;
		let r = Reflect.get(e, t), { enumerable: i } = Reflect.getOwnPropertyDescriptor(e, t), o = {
			value: r,
			enumerable: i,
			configurable: !0
		};
		if (Z.has(r)) J(r, !1);
		else if (r instanceof Promise) delete o.value, o.get = () => n(r);
		else if (X.has(r)) {
			let [e, t] = X.get(r);
			o.value = a(e, t(), n);
		}
		Object.defineProperty(s, t, o);
	}), Object.preventExtensions(s);
}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], c = (r) => {
	if (!Y(r)) throw Error("object required");
	let i = o.get(r);
	if (i) return i;
	let l = s[0], u = /* @__PURE__ */ new Set(), d = (e, t = ++s[0]) => {
		l !== t && (l = t, u.forEach((n) => n(e, t)));
	}, f = s[1], p = (e = ++s[1]) => (f !== e && !u.size && (f = e, h.forEach(([t]) => {
		let n = t[1](e);
		n > l && (l = n);
	})), l), m = (e) => (t, n) => {
		let r = [...t];
		r[1] = [e, ...r[1]], d(r, n);
	}, h = /* @__PURE__ */ new Map(), g = (e, t) => {
		if (u.size) {
			let n = t[3](m(e));
			h.set(e, [t, n]);
		} else h.set(e, [t]);
	}, _ = (e) => {
		var t;
		let n = h.get(e);
		n && (h.delete(e), (t = n[1]) == null || t.call(n));
	}, v = (e) => (u.add(e), u.size === 1 && h.forEach(([e, t], n) => {
		let r = e[3](m(n));
		h.set(n, [e, r]);
	}), () => {
		u.delete(e), u.size === 0 && h.forEach(([e, t], n) => {
			t && (t(), h.set(n, [e]));
		});
	}), y = Array.isArray(r) ? [] : Object.create(Object.getPrototypeOf(r)), b = t(y, {
		deleteProperty(e, t) {
			let n = Reflect.get(e, t);
			_(t);
			let r = Reflect.deleteProperty(e, t);
			return r && d([
				"delete",
				[t],
				n
			]), r;
		},
		set(t, r, i, a) {
			let s = Reflect.has(t, r), l = Reflect.get(t, r, a);
			if (s && (e(l, i) || o.has(i) && e(l, o.get(i)))) return !0;
			_(r), Y(i) && (i = me(i) || i);
			let u = i;
			if (i instanceof Promise) i.then((e) => {
				i.status = "fulfilled", i.value = e, d([
					"resolve",
					[r],
					e
				]);
			}).catch((e) => {
				i.status = "rejected", i.reason = e, d([
					"reject",
					[r],
					e
				]);
			});
			else {
				!X.has(i) && n(i) && (u = c(i));
				let e = !Z.has(u) && X.get(u);
				e && g(r, e);
			}
			return Reflect.set(t, r, u, a), d([
				"set",
				[r],
				i,
				l
			]), !0;
		}
	});
	o.set(r, b);
	let x = [
		y,
		p,
		a,
		v
	];
	return X.set(b, x), Reflect.ownKeys(r).forEach((e) => {
		let t = Object.getOwnPropertyDescriptor(r, e);
		"value" in t && (b[e] = r[e], delete t.value, delete t.writable), Object.defineProperty(y, e, t);
	}), b;
}) => [
	c,
	X,
	Z,
	e,
	t,
	n,
	r,
	i,
	a,
	o,
	s
])();
function Q(e = {}) {
	return he(e);
}
function ge(e, t, n) {
	let r = X.get(e), i, a = [], o = r[3], s = !1, c = o((e) => {
		if (a.push(e), n) {
			t(a.splice(0));
			return;
		}
		i ||= Promise.resolve().then(() => {
			i = void 0, s && t(a.splice(0));
		});
	});
	return s = !0, () => {
		s = !1, c();
	};
}
function _e(e, t) {
	let [n, r, i] = X.get(e);
	return i(n, r(), t);
}
//#endregion
//#region src/hooks/useCategoryOpen/store.ts
var $ = Q({}), ve = { reset() {
	Object.keys($).forEach((e) => delete $[e]);
} };
//#endregion
export { S as _, ge as a, ie as b, fe as c, u as d, o as f, v as g, g as h, _e as i, a as l, re as m, $ as n, K as o, te as p, Q as r, q as s, ve as t, f as u, b as v, w as y };

//# sourceMappingURL=store-VaTxVx1V.js.map